 
/**
 * @fileoverview This file contains all the scripts used in phone/###/###/####.
 * If a script is not used on these pages, please consider moving it to the correct file
 */
import $ from "jquery";
import "jquery-validation";
import "jquery-mask-plugin";
import "jquery-smooth-scroll";

window.jQuery = $;
window.$ = $;
window.$ = $;

import * as commonJS from "./common.js";
import * as phoneNumber from "./phone_number.ts";
import * as account from "./account.js";
import {
  loadCarrierAndLocation,
  enableViewMoreFunctionality,
} from "./components/table_most_searched_by_npa.js";
import {
  loadRelatedPhonesData,
} from "./components/related_phone_numbers.js";

document.addEventListener("DOMContentLoaded", function () {
  loadCarrierAndLocation();
  enableViewMoreFunctionality();
  loadRelatedPhonesData();
});

// This export is important to ensure webpack detects the JS and does not skip it during cleaning
export {
  commonJS,
  phoneNumber,
  account,
  loadCarrierAndLocation,
  enableViewMoreFunctionality,
  loadRelatedPhonesData,
};
